(function (window, document) {
  // Find CTA with `data-modal-id`.
  const cta = document.querySelector('[data-modal-id^="consumer-rx-modal"]');
  // If no CTA is found, do nothing.
  if (!cta) return;
  const modalModifiers = {
    optical: 'optical',
    opticalSun: 'optical-sun',
    opticalClipOn: 'optical-clip-on',
  };
  // Declare variables that keep track of what’s currently selected.
  let sunLensSelected = false, clipOnEnabled = false;

  window.componentEvents.on('swatch-list-toggle', (data) => {
    handleSwatchListToggle(data);
    changeTargetModalId();
  });

  window.componentEvents.on('swatch-list-update', (data) => {
    handleSwatchListUpdate(data);
    changeTargetModalId();
  });

  /**
   * Update sunLensSelected according to the selected lens color.
   */
  function handleSwatchListUpdate(data) {
    // If the swatch is not about lens color, do nothing.
    if (data.feature !== 'lens-color') return;
    sunLensSelected = data.swatch.dataset.lensColorId !== 'clear-lenses';
  }

  /**
   * Update clipOnEnabled according to the state of the toggle.
   */
  function handleSwatchListToggle(data) {
    // If the toggle is not about clip-on selection, do nothing.
    if (data.feature !== 'clip-on-color') return;
    clipOnEnabled = data.state === 'expanded';
  }

  /**
   * Update the CTA’s data-modal-id attribute if a corresponding modal is
   * loaded on the page.
   */
  function changeTargetModalId() {
    let modifier;
    if (clipOnEnabled) {
      modifier = modalModifiers.opticalClipOn;
    } else if (sunLensSelected) {
      modifier = modalModifiers.opticalSun;
    } else {
      modifier = modalModifiers.optical;
    }
    const modalId = `consumer-rx-modal--${modifier}`;
    // If modal is not loaded on the page, print warning to console and exit.
    if (!document.getElementById(modalId)) {
      // eslint-disable-next-line no-console
      return console.warn(`Cannot set CTA’s data-modal-id value because consumer-rx-modal--${modifier} is not loaded on the page.`);
    }

    cta.dataset.modalId = modalId;
  }
})(window, document);
